import React from 'react'
import Icon from 'blocks.simple/icon/icon'
import { text as textStyles } from 'theme'
import { cn } from 'ethcss'
import styles from './selectListItem.jcss'
import type { SelectListItemDefaultProps, SelectListItemProps } from './selectListItem.types'

const SelectListItem = (p_: SelectListItemProps) => {
    return (
        <span
            className={cn(styles.item, textStyles[p_.mod], p_.className)}
            onClick={p_.onClick ? p_.onClick : () => {}}
        >
            {p_.value}
            {p_.onIconClick && (
                <span className={styles.icon}>
                    <Icon type="close" iconColor={p_.mod} size="10" onClick={p_.onIconClick} />
                </span>
            )}
        </span>
    )
}

const defaultProps: SelectListItemDefaultProps = {
    mod: 'darkCloud',
}

SelectListItem.defaultProps = defaultProps

export default SelectListItem
